export const mesageConstants = {
    SUCCESS: 'ALERT_SUCCESS',
    ERROR: 'ALERT_ERROR',
    INFO: 'ALERT_INFO',
    CLEAR: 'ALERT_CLEAR',
    SUBMIT_SUCCESS: 'SUBMIT_SUCCESS',
    COPYED: 'COPYED'
};
